export { default } from "./AppFooter";
